let lockCount = 0
let initialOverflow = ''

export const lockBodyScroll = (): (() => void) => {
	if (lockCount === 0) {
		initialOverflow = document.body.style.overflow
		document.body.style.overflow = 'hidden'
	}

	lockCount += 1
	let isUnlocked = false

	return () => {
		if (isUnlocked) return

		isUnlocked = true
		lockCount = Math.max(0, lockCount - 1)

		if (lockCount === 0) document.body.style.overflow = initialOverflow
	}
}
